export enum UiSite {
  APP = 'APP',
  IMPORTSIGN = 'IMPORTSIGN',
  MARKETING = 'MARKETING',
}
